(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleansing"] && !Shopify.designMode) return;
  try {
    
    const dropdown = document.querySelector(".dropdown");
    const select = dropdown.querySelector(".dropdown-select");
    const menu = dropdown.querySelector(".dropdown-menu");
    const selectedText = select.querySelector("span[data-selected-text]");
    const items = dropdown.querySelectorAll(".dropdown-item");

    // Toggle dropdown on click
    select.addEventListener("click", () => {
      menu.classList.toggle("show");
    });

    // Handle item selection
    items.forEach(item => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");
        const item_otext = item.innerHTML.trim();
        const text = item.getAttribute('data-text');
        selectedText.innerHTML = item_otext;
        selectedText.setAttribute("data-selected-text", value);
        menu.classList.remove("show");

        document.querySelectorAll('.variant-picker').forEach(function (variant_picker) {
            variant_picker.querySelector('input[value="'+text+'"]').click();
        })
        // document.querySelectorAll('.products-container form [name="quantity"]').forEach(function (form_quantity) {
        //     form_quantity.value = value;
        // });

        //  document.querySelectorAll('.current-price').forEach(function (current_price) {
        //   var current__price = current_price.getAttribute('data-current-price').split(current_currency)[1];
        //   var new_current_price = (current__price * value).toFixed(2);
        //   current_price.textContent = current_currency + new_current_price;
        //  });  

        //  document.querySelectorAll('.original-price').forEach(function (original_price) {
        //   var original__price = original_price.getAttribute('data-original-price').split(current_currency)[1];
        //   var new_original_price = (original__price * value).toFixed(2);
        //   original_price.textContent = current_currency + new_original_price;  
        //  });

        //  document.querySelectorAll('.save-tag').forEach(function (save___price) {
        //   var save__price = save___price.getAttribute('data-save-tag').split(current_currency)[1];
        //   var new_save_price = (save__price * value).toFixed(2);
        //   save___price.textContent = 'SAVE ' + current_currency + new_save_price;  
        //  });
        
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target)) {
        menu.classList.remove("show");
      }
    });

  document.querySelectorAll('.product-toggle-buttons button').forEach(function (toggle_btn) {
   toggle_btn.addEventListener('click', function () {
      document.querySelector('.product-toggle-buttons .toggle-btn.selected').classList.remove('selected');  
      this.classList.add('selected');
      var current_attr = this.getAttribute('data-show');
      var product_attr = document.querySelector('.cleanse-product-section .product-card[data-product-id="'+current_attr+'"]');
      document.querySelectorAll('.cleanse-product-section .product-card').forEach(function (product_card) {
          product_card.style.display = 'none';
      });
      product_attr.style.display = 'block';
   });
  });

  document.querySelectorAll('.product-card .variant-option').forEach(function (card_variant_option) {
    card_variant_option.querySelectorAll('input').forEach(function (currentInput) {
     currentInput.addEventListener('change' , function () {
         var current_variant_id = this.dataset.variantId;
         this.closest('form').querySelector('.variant-input').value = current_variant_id;
         this.closest('form').querySelector('.current-price').textContent = current_currency + this.dataset.price;
         this.closest('form').querySelector('.original-price').textContent = current_currency + this.dataset.cprice;
         this.closest('form').querySelector('.save-tag').textContent = 'SAVE ' + current_currency + this.dataset.save;
         var current_variant_value = this.value.split(' ')[0];
         var per_person_value = (parseFloat(this.dataset.price) / current_variant_value).toFixed(2);
         this.closest('form').querySelector('.per-person sp').textContent = current_currency + per_person_value;
     });
    })
  });

    // Guide Modal Functionality
  document.addEventListener('DOMContentLoaded', function() {
      const modal = document.getElementById('guideModal');
      const openBtn = document.getElementById('openGuideModal');
      const closeBtn = document.getElementById('closeGuideModal');
      
      if (modal && openBtn && closeBtn) {
          // Open modal
          openBtn.addEventListener('click', function(e) {
              e.preventDefault();
              modal.classList.add('show');
              document.body.style.overflow = 'hidden';
          });
  
          // Close modal functions
          function closeModal() {
              modal.classList.remove('show');
              document.body.style.overflow = '';
          }
  
          closeBtn.addEventListener('click', closeModal);
  
          // Close on background click
          modal.addEventListener('click', function(e) {
              if (e.target === modal) {
                  closeModal();
              }
          });
  
          // Close on Escape key
          document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape' && modal.classList.contains('show')) {
                  closeModal();
              }
          });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
